// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslateButton-cls1_d1o","cls2":"TranslateButton-cls2_6GT TranslateButton-cls1_d1o"};